export const state = {
  questions: {},
  lists: {}
}

export default state
